import React from 'react';

const SuccessScreen: React.FC = (): React.ReactElement => {
  return (
    <section>
      Success screen
    </section>
  );
}

export default SuccessScreen;
